'use client';

import { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { subscribeVersionSkew } from 'src/lib/analytics/version-skew';

import { Iconify } from 'src/components/iconify';

import RoundedDialog from './RoundedDialog';

/**
 * **새 배포 알림** — 서버가 이 번들보다 새 판을 돌리고 있을 때 한 번 띄운다.
 *
 * 어긋남 판정은 `src/lib/analytics/version-skew.ts` 가 한다(수집 응답의 `x-app-version`).
 * 닫으면 이 페이지 수명 안에서는 다시 뜨지 않는다 — 판정도 한 번뿐이다.
 * 전 화면 공용이라 `<AnalyticsProvider>` 가 마운트한다.
 *
 * 닫기 X 는 두지 않는다 — 나가는 문은 「나중에」 하나다(X 와 둘이면 같은 뜻의 버튼이 둘이 된다).
 */
export function AppVersionRefreshDialog() {
  const [open, setOpen] = useState(false);

  useEffect(() => subscribeVersionSkew(() => setOpen(true)), []);

  return (
    <RoundedDialog
      open={open}
      onClose={() => setOpen(false)}
      showClose={false}
      maxWidth="xs"
      paperBg="background.paper"
      paperPadding={{ xs: '24px', sm: '28px' }}
      headerSx={{ mb: 1.5 }}
      actionsSx={{ justifyContent: 'center' }}
      title={<RefreshTitle />}
      actions={
        <>
          <Button color="inherit" variant="text" onClick={() => setOpen(false)}>
            나중에
          </Button>
          <Button color="primary" variant="contained" onClick={() => window.location.reload()}>
            업데이트 하기
          </Button>
        </>
      }
    >
      <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', lineHeight: 1.8 }}>
        업데이트하면 최신 화면으로 바로 이어집니다.
        <br />
        작성 중인 내용이 있다면 먼저 저장해 주세요.
      </Typography>
    </RoundedDialog>
  );
}

/** 로켓 아이콘과 한 줄 제목 — 가운데 정렬 */
function RefreshTitle() {
  return (
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      <Box
        sx={{
          width: 52,
          height: 52,
          mx: 'auto',
          mb: 1.5,
          borderRadius: '50%',
          bgcolor: 'primary.lighter',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Iconify icon="carbon:rocket" width={28} sx={{ color: 'primary.main' }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        더 나아진 캐치모먼츠가 준비됐어요
      </Typography>
    </Box>
  );
}
